import React, { useEffect, useState, useRef } from "react";
import { FiDownload as DownloadIcon } from "react-icons/fi";
import PaymentServices from "../../services/externalServices/TicketServices/paymentServicesV2";
import RefundServices from "../../services/externalServices/TicketServices/refundServices";
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServicesV2";
import ticketicon from "../../../assets/images/Ticket-icon.png";
import purchaseCost from "../../../assets/images/PurchaseCost.png";
import movieicon from "../../../assets/images/movie-icon.png";
import showicon from "../../../assets/images/show-icon.png";
import revenueicon from "../../../assets/images/revenue.png";


const SingleReport = () => {
    const [ticketData, setTicketData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refundLoading, setRefundLoading] = useState(false);
    
    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [otpSending, setOtpSending] = useState(false);
    const [otpVerifying, setOtpVerifying] = useState(false);
    const [otpValue, setOtpValue] = useState("");
    const [otpMessage, setOtpMessage] = useState("");
    const [otpError, setOtpError] = useState("");
    const [currentRefundBookingId, setCurrentRefundBookingId] = useState(null);
    const [otpCompleted, setOtpCompleted] = useState(false);
    const [statusLoading, setStatusLoading] = useState(false);
    const [orderBy, setOrderBy] = useState("showDate");
    const [order, setOrder] = useState("desc");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    // Filters
    const [dateOption, setDateOption] = useState("today");
    const [customRange, setCustomRange] = useState({ start: "", end: "" });
    const [theatreFilter, setTheatreFilter] = useState("");
    const [movieFilter, setMovieFilter] = useState("");
    const [selectedMovies, setSelectedMovies] = useState([]);
    const [showTimeFilter, setShowTimeFilter] = useState("");
    const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState('SUCCESS_OR_COMPLETED');
    const [includeArchived, setIncludeArchived] = useState(false);
    const [availableDates, setAvailableDates] = useState([]);
    const [availableMovies, setAvailableMovies] = useState([]);
    const [availableShowTimes, setAvailableShowTimes] = useState([]);
    const [theatres, setTheatres] = useState([]);


    const [selectedTheatre, setSelectedTheatre] = useState('');


    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || '{}');


    const isTicketAdmin = role === "ticket-admin";
    const theatreName = accessList?.[0];

    // Add a selector for date type
    const [dateType, setDateType] = useState("booking"); // "booking" or "show"

    const [copyStatus, setCopyStatus] = useState('');
    const [globalSearch, setGlobalSearch] = useState('');
    const [showColumnFilters, setShowColumnFilters] = useState(false);
    const [columnFilters, setColumnFilters] = useState({});
    const [visibleColumns, setVisibleColumns] = useState({});

    const reportColumns = [
        { label: "Booking Date", field: "bookingDate" },
        { label: "Booking Time", field: "bookingTime" },
        { label: "Show Date", field: "showDate" },
        { label: "Show Time", field: "showTime" },
        { label: "Booking Id", field: "bookingId" },
        { label: "Movie", field: "movieName" },
        { label: "Theatre", field: "theatreName" },
        { label: "User PhoneNumber", field: "userPhoneNumber" },
        { label: "Seats", field: "bookedSeats" },
        { label: "Amount", field: "totalAmount" },
        { label: "Payment Method", field: "paymentMethod" },
        { label: "Payment Mode", field: "paymentMode" },
        { label: "Transaction ID", field: "transactionId" },
        { label: "Status", field: "transactionStatus" },
        { label: "Invoice Number", field: "invoiceNumber" },
        { label: "Purchase Cost", field: "purchaseCost" },
        { label: "Base Amount", field: "priceSplit.baseAmount.value" },
        { label: "Total Tax", field: "priceSplit.totalTax.value" },
        { label: "Platform Fee", field: "priceSplit.platformFee.total.value" },
        { label: "Gateway Charges", field: "priceSplit.gatewayCharges.total.value" },
        { label: "Discount", field: "priceSplit.discount.value" },
        { label: "Merchant Txn ID", field: "paymentDetails.merchantTransactionId" },
        { label: "Payment Reference", field: "paymentReference" },
        { label: "Account Holder", field: "paymentDetails.paymentInstrument.accountHolderName" },
        { label: "Payment Type", field: "paymentDetails.paymentInstrument.type" },
        { label: "Account Type", field: "paymentDetails.paymentInstrument.accountType" },
        { label: "UserId", field: "userId" },
        // { label: "Refund", field: "refund", adminOnly: true }
    ];

    const isColVisible = (f) => visibleColumns[f] !== false; // default true


    const isInitialMount = useRef(true);

    let isRefundDisabled = false;

    const [refundedBookings, setRefundedBookings] = useState(new Set());




    // const isRefundDisabled = refundLoading || (t.refundTransactionId && t.refundStatus !== "FAILED" && t.refundStatus !== "NOT_INITIATED");


    // Fetch theatres on component mount









    useEffect(() => {
        const fetchTheatres = async () => {
            const res = await TheatreServices.getTheatres();

            console.log('response in the theaters========', res);
            if (Array.isArray(res)) {
                let filtered = res;
                if (role === "ticket-admin") {
                    filtered = res.filter(t => accessList.includes(t.name));
                }
                setTheatres(filtered);
                // if (filtered.length > 0) {
                //     setTheatreFilter(filtered[0].name)

                //     //   setSelectedTheatre(filtered[0].name);
                //     //   setFormData(prev => ({ ...prev, theatreId: filtered[0]._id }));
                // }
            }
        };

        fetchTheatres();
    }, []);




    // Fetch available movies and schedules when theatre changes
    useEffect(() => {
        if (theatreFilter) {

            fetchMoviesAndSchedules();
        } else {
            setAvailableMovies([]);
            setAvailableDates([]);
            setAvailableShowTimes([]);
            setMovieFilter("");
            setSelectedMovies([]);
            setShowTimeFilter("");
        }
    }, [theatreFilter]);




    // for the refund and the refund status

    const handleRefund = async (bookingId, { silent = false } = {}) => {
        setRefundLoading(true);
        try {
            // Call backend refund API with bookingId
            console.log('hitting the function handlerefund', bookingId)
            console.log('typeof hitting the function handlerefund', typeof bookingId)

            const result = await PaymentServices.refundBooking(bookingId);

            console.log('log of the api ', result)

            if (result?.refundTransactionId) {
                // Show success feedback that refund was initiated
                if (!silent) {
                    alert("Refund initiated. Use 'Check Status' to track.\nRefund Txn ID: " + result.refundTransactionId);
                }
                // isRefundDisabled = true;

                setRefundedBookings((prev) => new Set(prev).add(String(bookingId))); // ✅ disable for this booking
                // Update table row locally to reflect initiation
                setFilteredData(prev => prev.map(t => (
                    String(t.bookingId) === String(bookingId) ? {
                        ...t,
                        refundTransactionId: result.refundTransactionId,
                        refundStatus: t.refundStatus || 'INITIATED'
                    } : t
                )));
                // Optionally update state/UI with refundTransactionId for this ticket
            } else {
                if (!silent) {
                    alert("Refund initiation failed. Please try again.");
                }
            }
        } catch (error) {
            console.error("Refund error:", error);
            if (!silent) {
                alert("Refund failed: " + (error.message || "Unknown error"));
            }
        } finally {
            setRefundLoading(false);
        }
    };

    // Open OTP modal and trigger OTP send
    const openOtpModalForRefund = async (bookingId) => {
        setCurrentRefundBookingId(bookingId);
        setOtpValue("");
        setOtpMessage("");
        setOtpError("");
        setOtpCompleted(false);
        setOtpModalOpen(true);
        // Trigger OTP send
        setOtpSending(true);
        try {
            const res = await RefundServices.sendRefundOtp(String(bookingId));
            // Handle various response shapes
            if (res?.success || res?.status === true) {
                setOtpMessage("OTP sent successfully. Please enter the code.");
            } else {
                setOtpMessage("");
                setOtpError(res?.message || "Failed to send OTP. Try again.");
            }
        } catch (e) {
            setOtpMessage("");
            setOtpError(e?.message || "Failed to send OTP. Try again.");
        } finally {
            setOtpSending(false);
        }
    };

    // Verify OTP and then initiate refund
    const verifyOtpAndRefund = async () => {
        if (!currentRefundBookingId) return;
        setOtpError("");
        if (!otpValue || String(otpValue).trim().length < 4) {
            setOtpError("Please enter a valid OTP.");
            return;
        }
        setOtpVerifying(true);
        try {
            const res = await RefundServices.verifyRefundOtp(String(currentRefundBookingId), String(otpValue).trim());

            const bidStr = String(currentRefundBookingId);
            console.log('res', res);
            console.log('bidStr', bidStr);
          

            // Extract a booking identifier from different possible response shapes
            let extracted = null;
            if (typeof res === 'string' || typeof res === 'number') {
                extracted = String(res);
            } else if (res && typeof res === 'object') {
                const candidates = [res.bookingId, res.id, res._id, res.data, res.result, res.message, res.value];
                for (const c of candidates) {
                    if (typeof c === 'string' || typeof c === 'number') { extracted = String(c); break; }
                    if (c && typeof c === 'object') {
                        const inner = [c.bookingId, c.id, c._id, c.result, c.value];
                        for (const ic of inner) { if (typeof ic === 'string' || typeof ic === 'number') { extracted = String(ic); break; } }
                        if (extracted) break;
                    }
                }
            }

            const isSuccess = (
                (extracted && (extracted === bidStr || extracted.includes(bidStr))) || (bidStr== res) ||
                (res && typeof res === 'object' && (res.success === true || res.status === true || res.verified === true))
            );


            console.log('isSuccess============',isSuccess);

            if (res.message=="Refund initiated") {
                // Mark UI success immediately
                setOtpCompleted(true);
                // Immediately disable refund button on the row
                setRefundedBookings((prev) => new Set(prev).add(bidStr));
                setFilteredData(prev => prev.map(t => (
                    String(t.bookingId) === bidStr ? { ...t, refundStatus: t.refundStatus || 'INITIATED' } : t
                )));
                // Initiate refund silently
                await handleRefund(bidStr, { silent: true });
                alert("Refund initiated. Please check the status in the report page.");
            } else {
                setOtpError(res?.message || "Incorrect OTP. Please try again.");
            }
        } catch (e) {
            setOtpError(e?.message || "OTP verification failed.");
        } finally {
            setOtpVerifying(false);
        }
    };

    const handleCheckStatus = async (bookingId) => {
        setStatusLoading(true);
        try {
            // Use backend API to check refund status by bookingId (backend will lookup refundTransactionId)


            console.log('hitting the function handlerefund', bookingId)
            console.log('typeof hitting the function handlerefund', typeof bookingId)
            const result = await PaymentServices.getRefundStatus(bookingId);


            console.log('result', result.phonepeResponse)

            if (result?.refundStatus == "SUCCESS") {
                // Display refund status to user
                alert("Refund Status: " + result.refundStatus);




                // Need to check and replace the status of the refund 

                setFilteredData((prev) =>
                    prev.map((t) =>
                        String(t.bookingId) === String(bookingId) ? { ...t, refundStatus: result.refundStatus } : t
                    )
                );



                // Optionally update UI/state with current refund status
            } else {
                alert("Refund status not found. You may need to initiate the refund first.");
            }
        } catch (error) {
            console.error("Status check error:", error);
            alert("Failed to retrieve refund status: " + (error.message || "Unknown error"));
        } finally {
            setStatusLoading(false);
        }
    };












    const fetchMoviesAndSchedules = async () => {
        try {
            setLoading(true);
            let response;

            // ✅ INVERT the includeArchived parameter for the API call
            const invertedIncludeArchived = !includeArchived;
            if (isInitialMount.current) {
                response = await MovieServices.getMoviesForReport({
                    theatreName: theatreFilter,
                    includeArchived: false  // Send inverted value to backend

                });
                isInitialMount.current = false;
            } else {
                response = await MovieServices.getMoviesForReport({
                    theatreName: theatreFilter,
                    includeArchived: invertedIncludeArchived  // Send inverted value to backend  
                })

            }

            console.log('includeArchived state (frontend):', includeArchived);
            console.log('includeArchived sent to backend:', invertedIncludeArchived);
            console.log('response of the movies:', response);

            // Get all movies from response
            const allMovies = Array.isArray(response) ? response :
                Array.isArray(response.data) ? response.data : [];

            // ✅ Since we're sending inverted param to backend, we can use movies directly

            const filteredMovies = allMovies


            // const filteredMovies = allMovies.filter(movie => 
            //   movie.isReadyForBooking && 
            //   movie.validities?.some(validity => 
            //     !validity.isArchived && validity.isReadyForBooking !== false
            //   )
            // );

            console.log('Filtered movies count:', filteredMovies.length);
            setAvailableMovies(filteredMovies);

            // Auto-select logic
            if (filteredMovies.length > 0 && !movieFilter) {
                setMovieFilter(filteredMovies[0].name);
                setSelectedMovies([filteredMovies[0].name]);
                updateShowTimesAndDates(filteredMovies[0]);
            } else if (movieFilter) {
                const selectedMovie = filteredMovies.find(m => m.name === movieFilter);
                if (selectedMovie) {
                    updateShowTimesAndDates(selectedMovie);
                } else {
                    setMovieFilter("");
                    setAvailableDates([]);
                    setAvailableShowTimes([]);
                }
            }
        } catch (err) {
            console.error("Error fetching movies:", err);
        } finally {
            setLoading(false);
        }
    };




    // const fetchMoviesAndSchedules = async () => {
    //     try {
    //         setLoading(true);

    //         // ✅ On initial mount, always get unarchived movies
    //         // On subsequent calls, use the checkbox state
    //         let shouldIncludeArchived;
    //         if (isInitialMount.current) {
    //             shouldIncludeArchived = false; // Always start with unarchived
    //             isInitialMount.current = false;
    //         } else {
    //             shouldIncludeArchived = includeArchived; // Use checkbox state
    //         }

    //         const response = await MovieServices.getMovies({
    //             theatreName: theatreFilter,
    //             includeArchived: shouldIncludeArchived
    //         });

    //         console.log('includeArchived state (frontend):', includeArchived);
    //         console.log('includeArchived sent to backend:', shouldIncludeArchived);
    //         console.log('response of the movies:', response);

    //         // Get all movies from response
    //         const allMovies = Array.isArray(response) ? response :
    //             Array.isArray(response.data) ? response.data : [];

    //         const filteredMovies = allMovies;

    //         console.log('Filtered movies count:', filteredMovies.length);
    //         setAvailableMovies(filteredMovies);

    //         // Auto-select logic remains the same
    //         if (filteredMovies.length > 0 && !movieFilter) {
    //             setMovieFilter(filteredMovies[0].name);
    //             updateShowTimesAndDates(filteredMovies);
    //         } else if (movieFilter) {
    //             const selectedMovie = filteredMovies.find(m => m.name === movieFilter);
    //             if (selectedMovie) {
    //                 updateShowTimesAndDates(selectedMovie);
    //             } else {
    //                 setMovieFilter("");
    //                 setAvailableDates([]);
    //                 setAvailableShowTimes([]);
    //             }
    //         }
    //     } catch (err) {
    //         console.error("Error fetching movies:", err);
    //     } finally {
    //         setLoading(false);
    //     }
    // };







    const updateShowTimesAndDates = (movie) => {
        const dates = new Set();
        const showTimes = new Set();

        movie.validities?.forEach(validity => {
            // Only filter validities if includeArchived is false
            if (!includeArchived && (validity.isArchived || !validity.isReadyForBooking)) {
                return;
            }

            validity.shows?.forEach(show => {
                if (show.enabledDates) {
                    show.enabledDates.forEach(date => dates.add(date));
                }
                if (show.time) showTimes.add(show.time);
            });
        });

        setAvailableDates(Array.from(dates).sort());
        setAvailableShowTimes(Array.from(showTimes).sort());
    };


    const fetchTicketData = async () => {
        try {
            setLoading(true);

            // Build query based on current filters
            const query = {
                theatreName: theatreFilter,
                status: statusFilter,
                paymentMethod: paymentMethodFilter,
                dateType, // booking or show
            };

            // Movies: support multi-select (send comma-separated string if multiple)
            if (Array.isArray(selectedMovies) && selectedMovies.length > 1) {
                query.movieName = selectedMovies.join(',');
            } else if (movieFilter) {
                query.movieName = movieFilter;
            }

            // Show time only when single movie selected
            if (showTimeFilter && (!selectedMovies || selectedMovies.length <= 1)) {
                query.showTime = showTimeFilter;
            }

            // Add date range
            let { start, end } = getDateRange();
            // If user selected theatre but provided no dates (e.g., custom blank), default to today
            if (!start && !end && theatreFilter) {
                const todayStart = new Date();
                const todayEnd = new Date();
                todayStart.setHours(0, 0, 0, 0);
                todayEnd.setHours(23, 59, 59, 999);
                start = todayStart;
                end = todayEnd;
            }
            if (start) query.startDate = start.toISOString();
            if (end) query.endDate = end.toISOString();

            const response = await PaymentServices.getSingleFullReport(query);


            console.log('response.data of the movies', response.data);

            const items = response.data || [];
            const normalizedStatus = (val) => String(val || '').toUpperCase();
            const filteredItems = items.filter((ticket) => {
                if (!statusFilter) return true;
                const st = normalizedStatus(ticket.transactionStatus);
                if (statusFilter === 'SUCCESS_OR_COMPLETED') {
                    return st === 'SUCCESS' || st === 'COMPLETED';
                }
                return st === normalizedStatus(statusFilter);
            });
            setTicketData(items);
            setFilteredData(filteredItems);

        } catch (err) {
            console.error("Error fetching ticket data:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSort = (field) => {
        const isAsc = orderBy === field && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(field);
    };










    // Filter data based on global search
    const getFilteredDataForSearch = () => {
        let base = filteredData;

        // Apply column filters first
        const entries = Object.entries(columnFilters).filter(([k, v]) => v && String(v).trim() !== '');
        if (entries.length) {
            base = base.filter(ticket => {
                return entries.every(([key, val]) => {
                    const v = String(val).toLowerCase();
                    const field = String((ticket[key] ?? '')).toLowerCase();
                    return field.includes(v);
                });
            });
        }

        // Then global search
        if (!globalSearch.trim()) return base;
        const searchTerm = globalSearch.toLowerCase().trim();

        return base.filter(ticket => {
            const searchFields = [
                ticket.bookingId,
                ticket.movieName,
                ticket.theatreName,
                ticket.userPhoneNumber,
                ticket.paymentMethod,
                ticket.transactionId,
                ticket.transactionStatus,
                ticket.invoiceNumber,
                ticket.showTime,
                ticket.showDate,
                ticket.bookingDate,
                ...(ticket.bookedSeats || [])
            ].filter(Boolean);
            return searchFields.some(field => String(field).toLowerCase().includes(searchTerm));
        });
    };


    // const sortedData = [...filteredData].sort((a, b) => {
    //     if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    //     if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    //     return 0;
    // });

    // Update your sorted and paginated data
    const searchFilteredData = getFilteredDataForSearch();


    const sortedData = [...searchFilteredData].sort((a, b) => {
        if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
        if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
        return 0;
    });

    const paginatedData = sortedData.slice(
        page * rowsPerPage,
        (page + 1) * rowsPerPage
    );

    const getDateRange = () => {
        const now = new Date();
        let start = new Date();
        let end = new Date();

        // Normalize times to beginning/end of day
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        switch (dateOption) {
            case "today":
                // already normalized above
                break;

            case "tomorrow":
                start.setDate(start.getDate() + 1);
                end.setDate(end.getDate() + 1);
                break;

            case "dayAfterTomorrow":
                start.setDate(start.getDate() + 2);
                end.setDate(end.getDate() + 2);
                break;

            case "yesterday":
                start.setDate(start.getDate() - 1);
                end.setDate(end.getDate() - 1);
                break;

            case "week":
                start.setDate(start.getDate() - 7);
                break;

            case "month":
                // Full current month
                start = new Date(now.getFullYear(), now.getMonth(), 1);
                end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
                break;

            case "year":
                // Full current year
                start = new Date(now.getFullYear(), 0, 1);
                end = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
                break;

            case "custom":
                return {
                    start: customRange.start ? new Date(customRange.start) : null,
                    end: customRange.end ? new Date(customRange.end) : null,
                };

            default:
                break;
        }

        return { start, end };
    };


    const formatTo12Hour = (dateTimeString) => {
        if (!dateTimeString) return "N/A";

        try {
            // Split the date and time
            const [datePart, timePart] = dateTimeString.split(' ');
            const [hours, minutes] = timePart.split(':');

            // Convert to 12-hour format
            const hour12 = parseInt(hours) % 12 || 12;
            const ampm = parseInt(hours) >= 12 ? 'PM' : 'AM';

            return `${datePart} ${hour12}:${minutes} ${ampm}`;
        } catch (error) {
            return dateTimeString; // Return original if conversion fails
        }
    };






    // const getDateOptions = () => {
    //     // Today
    //     const today = new Date();
    //     const todayStr = today.toISOString().split("T")[0];

    //     // Yesterday
    //     const yesterday = new Date(today);
    //     yesterday.setDate(yesterday.getDate() - 1);
    //     const yesterdayStr = yesterday.toISOString().split("T")[0];

    //     // Tomorrow
    //     const tomorrow = new Date(today);
    //     tomorrow.setDate(tomorrow.getDate() + 1);
    //     const tomorrowStr = tomorrow.toISOString().split("T")[0];

    //     // Day After Tomorrow
    //     const dayAfterTomorrow = new Date(today);
    //     dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
    //     const dayAfterTomorrowStr = dayAfterTomorrow.toISOString().split("T")[0];

    //     // Get enabled dates for the selected movie and show time
    //     const enabledDates = movieFilter
    //         ? (() => {
    //             const selectedMovie = availableMovies.find(m => m.name === movieFilter);
    //             if (!selectedMovie) return [];

    //             const dates = new Set();
    //             selectedMovie.validities?.forEach(validity => {
    //                 validity.shows?.forEach(show => {
    //                     if ((!showTimeFilter || show.time === showTimeFilter) && show.enabledDates) {
    //                         show.enabledDates.forEach(date => dates.add(date));
    //                     }
    //                 });
    //             });
    //             return Array.from(dates);
    //         })()
    //         : availableDates; // Fallback to all dates if no movie selected

    //     const options = [
    //         { value: "today", label: "Today", available: enabledDates.includes(todayStr) },
    //         { value: "tomorrow", label: "Tomorrow", available: enabledDates.includes(tomorrowStr) },
    //         { value: "dayAfterTomorrow", label: "Day After Tomorrow", available: enabledDates.includes(dayAfterTomorrowStr) },
    //         { value: "yesterday", label: "Yesterday", available: enabledDates.includes(yesterdayStr) },
    //         { value: "week", label: "Last 7 Days" },
    //         { value: "month", label: "This Month" },
    //         { value: "year", label: "This Year" },
    //         { value: "custom", label: "Custom Range" }
    //     ];

    //     return options.filter(opt => opt.available !== false);
    // };













    // const getDateOptions = () => {
    //     const today = new Date();
    //     const iso = date => date.toISOString().split("T")[0];

    //     const todayStr           = iso(today);
    //     const yesterdayStr       = iso(new Date(today.getTime() - 864e5));
    //     const tomorrowStr        = iso(new Date(today.getTime() + 864e5));
    //     const dayAfterTomorrowStr= iso(new Date(today.getTime() + 2 * 864e5));

    //     // Determine source dates based on dateType
    //     let sourceDates;
    //     if (dateType === "booking") {
    //       // Always allow booking-date ranges regardless of show schedule
    //       sourceDates = [yesterdayStr, todayStr, tomorrowStr, dayAfterTomorrowStr];
    //     } else {
    //       // Only those dates on which the selected show is enabled
    //       sourceDates = movieFilter
    //         ? (() => {
    //             const sel = availableMovies.find(m => m.name === movieFilter);
    //             if (!sel) return [];
    //             const s = new Set();
    //             sel.validities?.forEach(v =>
    //               v.shows?.forEach(sh =>
    //                 sh.enabledDates?.forEach(d => s.add(d))
    //               )
    //             );
    //             return Array.from(s);
    //           })()
    //         : availableDates;
    //     }

    //     // Build options; include only those flagged “available” (booking always available)
    //     const options = [
    //       { value: "yesterday",       label: "Yesterday",             available: sourceDates.includes(yesterdayStr) },
    //       { value: "today",           label: "Today",                 available: sourceDates.includes(todayStr) },
    //       { value: "tomorrow",        label: "Tomorrow",              available: sourceDates.includes(tomorrowStr) },
    //       { value: "dayAfterTomorrow",label: "Day After Tomorrow",    available: sourceDates.includes(dayAfterTomorrowStr) },
    //       { value: "week",            label: "Last 7 Days",           available: true },
    //       { value: "month",           label: "This Month",            available: true },
    //       { value: "year",            label: "This Year",             available: true },
    //       { value: "custom",          label: "Custom Range",          available: true }
    //     ];

    //     return options.filter(opt => opt.available !== false);
    //   };






    const getDateOptions = () => {
        const now = new Date();
        const iso = date => date.toISOString().split("T")[0];

        const dates = {
            yesterday: iso(new Date(now.getTime() - 864e5)),
            today: iso(now),
            tomorrow: iso(new Date(now.getTime() + 864e5)),
            dayAfterTomorrow: iso(new Date(now.getTime() + 2 * 864e5))
        };

        // Always show all four options
        const options = [
            { value: "yesterday", label: "Yesterday" },
            { value: "today", label: "Today" },
            { value: "tomorrow", label: "Tomorrow" },
            { value: "dayAfterTomorrow", label: "Day After Tomorrow" },
            { value: "week", label: "Last 7 Days" },
            { value: "month", label: "This Month" },
            { value: "year", label: "This Year" },
            { value: "custom", label: "Custom Range" }
        ];

        // Determine availability for the four day-options
        const availability = options.map(opt => {
            if (["week", "month", "year", "custom"].includes(opt.value)) {
                return { ...opt, enabled: true };
            }

            const isoDate = dates[opt.value];
            if (dateType === "booking") {
                // Check if any booking exists on that date
                return {
                    ...opt,
                    enabled: ticketData.some(t =>
                        t.bookingDate?.split("T")[0] === isoDate
                    )
                };
            } else {
                // Check if the show is available on that date
                const sel = availableMovies.find(m => m.name === movieFilter);
                const enabledDates = new Set(
                    sel?.validities.flatMap(v =>
                        v.shows.flatMap(s => s.enabledDates || [])
                    ) || []
                );
                return { ...opt, enabled: enabledDates.has(isoDate) };
            }
        });

        // Filter out unavailable options only if you want to hide them;
        // otherwise render them disabled in the UI
        return availability;
    };



    const exportCSV = () => {
        try {
            setLoading(true);

            const headers = [
                "Booking Date", "Booking Time", "Show Date", "Show Time", "Booking Id",
                "Movie", "Theatre", "User PhoneNumber", "Seats", "Amount", "Payment Method",
                "Payment Mode", "Transaction ID", "Status", "Invoice Number", "Purchase Cost",
                "Base Amount", "Total Tax", "Platform Fee", "Gateway Charges", "Discount",
                "Merchant Transaction ID", "UTR", "UPI Transaction ID", "ARN",
                "Account Holder Name", "Payment Type", "Account Type", "Card Network"
            ];

            const rows = filteredData.map((ticket) => {
                const instrument = ticket.paymentDetails?.paymentInstrument;

                return [
                    ticket.bookingDate?.split(' ')[0] ? formatDateToDDMMYYYY(ticket.bookingDate.split(' ')[0]) : "",
                    ticket.bookingDate?.split(' ')[1] || "",
                    ticket.showDate ? formatDateToDDMMYYYY(ticket.showDate) : "",
                    ticket.showTime || "",
                    ticket.bookingId || "",
                    ticket.movieName || "",
                    ticket.theatreName || "",
                    ticket.userPhoneNumber || "",
                    Array.isArray(ticket.bookedSeats) ? ticket.bookedSeats.join("; ") : "",
                    ticket.totalAmount || "0",
                    ticket.paymentMethod || "",
                    ticket.paymentMode || "",
                    ticket.transactionId || "",
                    ticket.transactionStatus || "",
                    ticket.invoiceNumber || "",
                    ticket.purchaseCost || "0",
                    ticket.priceSplit?.baseAmount?.value || "0",
                    ticket.priceSplit?.totalTax?.value || "0",
                    ticket.priceSplit?.platformFee?.total?.value || "0",
                    ticket.priceSplit?.gatewayCharges?.total?.value || "0",
                    ticket.priceSplit?.discount?.value || "0",
                    ticket.paymentDetails?.merchantTransactionId || "",
                    instrument?.utr || "",
                    instrument?.upiTransactionId || "",
                    instrument?.arn || "",
                    instrument?.accountHolderName || "",
                    instrument?.type || "",
                    instrument?.accountType || "",
                    instrument?.cardNetwork || ""
                ];
            });

            // Create CSV with BOM for proper Unicode support
            const BOM = '\uFEFF';
            const csvContent = BOM + [
                headers.join(","),
                ...rows.map((row) =>
                    row.map((field) => {
                        const str = (field?.toString() || "").replace(/"/g, '""');
                        return `"${str}"`;
                    }).join(",")
                ),
            ].join("\n");

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
            const filename = `booking_report_${timestamp}.csv`;

            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error("❌ CSV Export failed:", error);
            alert("Export failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };











    const copyTableToClipboard = () => {
        try {
            // Define headers
            const headers = [
                "Booking Date", "Booking Time", "Show Date", "Show Time", "Booking Id",
                "Movie", "Theatre", "User PhoneNumber", "Seats", "Amount", "Payment Method",
                "Payment Mode", "Transaction ID", "Status", "Invoice Number", "Purchase Cost"
            ];

            // Create table data with formatted phone numbers
            const tableData = paginatedData.map((ticket) => {



                const phoneNumber = ticket.userPhoneNumber ?
                    (ticket.userPhoneNumber.startsWith('+') ? ticket.userPhoneNumber : `+${ticket.userPhoneNumber}`)
                    : '';

                return [
                    ticket.bookingDate?.split(' ')[0] ? formatDateToDDMMYYYY(ticket.bookingDate.split(' ')) : "",
                    ticket.bookingDate?.split(' ')[1] || "",
                    ticket.showDate ? formatDateToDDMMYYYY(ticket.showDate) : "",
                    ticket.showTime || "",
                    ticket.bookingId || "",
                    ticket.movieName || "",
                    ticket.theatreName || "",
                    ticket.userPhoneNumber || "",
                    // phoneNumber, // ✅ Formatted with +
                    Array.isArray(ticket.bookedSeats) ? ticket.bookedSeats.join(", ") : "",
                    ticket.totalAmount || "0",
                    ticket.paymentMethod || "",
                    ticket.paymentMode || "",
                    ticket.transactionId || "",
                    ticket.transactionStatus || "",
                    ticket.invoiceNumber || "",
                    ticket.purchaseCost || "0"
                ];
            });

            // Create tab-separated values for better Excel/Sheets compatibility
            const tsvContent = [
                headers.join('\t'),
                ...tableData.map(row => row.join('\t'))
            ].join('\n');

            // Copy to clipboard
            navigator.clipboard.writeText(tsvContent).then(() => {
                setCopyStatus('✅ Copied!');
                setTimeout(() => setCopyStatus(''), 2000);
            }).catch(() => {
                setCopyStatus('❌ Failed');
                setTimeout(() => setCopyStatus(''), 2000);
            });
        } catch (error) {
            console.error('Copy failed:', error);
            setCopyStatus('❌ Failed');
            setTimeout(() => setCopyStatus(''), 2000);
        }
    };


    const getOptions = (field, base = filteredData) => {
        return [...new Set(base.map((t) => t[field]))].filter(Boolean).sort();
    };

    const clearFilters = () => {
        setDateOption("today");
        setCustomRange({ start: "", end: "" });
        setTheatreFilter("");
        setMovieFilter("");
        setSelectedMovies([]);
        setShowTimeFilter("");
        setPaymentMethodFilter("");
        setStatusFilter('SUCCESS_OR_COMPLETED');
        setIncludeArchived(false);
    };

    const formatDateToDDMMYYYY = (dateInput) => {
        if (!dateInput) return "";
        const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
        if (isNaN(date.getTime())) return "Invalid date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(
            date.getMonth() + 1
        ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const calculateMetrics = (data) => {
        if (data.length === 0) {
            return {
                totalTickets: 0,
                totalRevenue: 0,
                avgPaymentCost: 0,
                mostPopularShowTime: "N/A",
                mostPopularMovie: "N/A",
                filteredMovie: null,
                showTimeFilter: null,
            };
        }

        // Count only seats from successful/confirmed bookings
        const OK = new Set(['COMPLETED','SUCCESS','CONFIRMED']);
        const totalTickets = data.reduce((sum, ticket) => {
            const st = String(ticket.transactionStatus || '').toUpperCase();
            const ok = OK.has(st);
            return sum + (ok ? (ticket.bookedSeats?.length || 0) : 0);
        }, 0);
        const totalRevenue = data.reduce(
            (sum, ticket) => sum + (ticket.totalAmount || 0),
            0
        );

        const uniqueMovieTheatrePairs = new Map();

        data.forEach((ticket) => {
            const key = `${ticket.movieName}-${ticket.theatreName}`;
            if (!uniqueMovieTheatrePairs.has(key) && ticket.purchaseCost) {
                uniqueMovieTheatrePairs.set(key, ticket.purchaseCost);
            }
        });

        const avgPaymentCost = [...uniqueMovieTheatrePairs.values()].reduce(
            (sum, cost) => sum + cost,
            0
        );

        // Check if we're filtering by a specific movie
        const uniqueMovies = [...new Set(data.map((item) => item.movieName))];
        const filteredMovie = uniqueMovies.length === 1 ? uniqueMovies[0] : null;

        const showTimeCounts = data.reduce((acc, ticket) => {
            acc[ticket.showTime] =
                (acc[ticket.showTime] || 0) + ticket.bookedSeats.length;
            return acc;
        }, {});

        const mostPopularShowTime =
            Object.entries(showTimeCounts).sort((a, b) => b[1] - a[1])[0]?.[0] ||
            "N/A";

        // Only calculate popular movie if not filtered by a specific movie
        let mostPopularMovie = "N/A";
        if (!filteredMovie) {
            const movieCounts = data.reduce((acc, ticket) => {
                acc[ticket.movieName] =
                    (acc[ticket.movieName] || 0) + ticket.bookedSeats.length;
                return acc;
            }, {});

            mostPopularMovie =
                Object.entries(movieCounts).sort((a, b) => b[1] - a[1])[0]?.[0] ||
                "N/A";
        }

        return {
            totalTickets,
            totalRevenue,
            mostPopularShowTime,
            mostPopularMovie,
            filteredMovie,
            avgPaymentCost,
            showTimeFilter,
        };
    };

    const findDuplicateSeats = () => {
        // First normalize all seat data for accurate comparison
        const normalizedData = filteredData.map(booking => ({
            ...booking,
            normalizedSeats: booking.bookedSeats.map(seat =>
                seat.trim().toLowerCase().replace(/\s+/g, ' ')
            ),
            originalSeats: booking.bookedSeats // Keep original for display
        }));

        // Group bookings by theater, date, and show time
        const grouped = normalizedData.reduce((acc, booking) => {
            const key = `${booking.theatreName}-${booking.showDate}-${booking.showTime}`;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(booking);
            return acc;
        }, {});

        // Find duplicates and track which seats are duplicated
        const duplicates = [];
        const duplicateDetails = [];

        Object.entries(grouped).forEach(([key, group]) => {
            if (group.length > 1) {
                // Collect all seats for this show
                const allSeatEntries = group.flatMap(booking =>
                    booking.normalizedSeats.map((seat, index) => ({
                        seat,
                        original: booking.originalSeats[index],
                        bookingId: booking.bookingId,
                        userPhone: booking.userPhoneNumber,
                        theatre: booking.theatreName,
                        showTime: booking.showTime,
                        showDate: booking.showDate
                    }))
                );

                // Find duplicates within these seats
                const seatCounts = allSeatEntries.reduce((counts, { seat }) => {
                    counts[seat] = (counts[seat] || 0) + 1;
                    return counts;
                }, {});

                const duplicatedSeats = Object.entries(seatCounts)
                    .filter(([_, count]) => count > 1)
                    .map(([seat]) => seat);

                if (duplicatedSeats.length > 0) {
                    // Find all bookings that have these duplicated seats
                    const duplicateBookings = group.filter(booking =>
                        booking.normalizedSeats.some(seat =>
                            duplicatedSeats.includes(seat)
                        )
                    );

                    duplicates.push(...duplicateBookings);

                    // Store detailed info about which seats are duplicated
                    duplicatedSeats.forEach(seat => {
                        const conflictingBookings = allSeatEntries
                            .filter(entry => entry.seat === seat)
                            .map(entry => ({
                                bookingId: entry.bookingId,
                                phone: entry.userPhone,
                                seat: entry.original
                            }));

                        duplicateDetails.push({
                            theatre: group[0].theatreName,
                            date: group[0].showDate,
                            time: group[0].showTime,
                            seat: allSeatEntries.find(e => e.seat === seat).original,
                            conflicts: conflictingBookings
                        });
                    });
                }
            }
        });

        if (duplicates.length > 0) {
            setFilteredData(duplicates);
            alert(`Found ${duplicates.length} bookings with duplicate seats`);
        } else {
            alert('No duplicate seat bookings found');
        }
    };

    const SummaryCards = ({ data }) => {

        console.log('data=====', data);
        const metrics = calculateMetrics(data);

        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 py-2 px-1">
                {/* Total Payment Cost Card */}
                <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-blue-500">
                    <div className="p-3 bg-blue-50 rounded-full">
                        <img src={purchaseCost} alt='payment' className='w-10 h-10' />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Payment Cost</h3>
                        <p className="text-2xl font-bold my-1 text-gray-800 truncate">
                            ₹{typeof metrics.avgPaymentCost === 'number'
                                ? metrics.avgPaymentCost.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : '0.00'}
                        </p>
                        <p className="text-gray-400 text-xs">Purchase cost of movie</p>
                    </div>
                </div>

                {/* Total Tickets Card */}
                <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-green-500">
                    <div className="p-3 bg-yellow-50 rounded-full">
                        <img src={ticketicon} alt='tickets' className='w-10 h-10' />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Tickets</h3>
                        <p className="text-2xl font-bold my-1 text-gray-800">{metrics.totalTickets}</p>
                        <p className="text-gray-400 text-xs">Booked seats</p>
                    </div>
                </div>



                {/* ✅ NEW: Booked Seats Count Card */}
                {dateType == 'show' &&


                    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-orange-500">
                        <div className="p-3 bg-orange-50 rounded-full">
                            <svg className="w-10 h-10 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">
                                Screen Booked Seats
                            </h3>
                            <p className="text-2xl font-bold my-1 text-gray-800">
                                {data && data.length ? (data[0].bookedSeatsCount ?? 0) : 0}
                            </p>
                            <p className="text-gray-400 text-xs">
                                Seats marked as booked (Stat=2)
                            </p>
                        </div>
                    </div>

                }



                {/* Total Revenue Card */}
                <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-purple-500">
                    <div className="p-3 bg-blue-50 rounded-full">
                        <img src={revenueicon} alt='revenue' className='w-10 h-10' />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Revenue</h3>
                        <p className="text-2xl font-bold my-1 text-gray-800">
                            ₹{metrics.totalRevenue.toLocaleString('en-IN')}
                        </p>
                        <p className="text-gray-400 text-xs">Total collected</p>
                    </div>
                </div>

                {metrics.showTimeFilter ? (
                    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
                        <div className="p-3 bg-purple-50 rounded-full">
                            <img src={showicon} alt='show' className='w-10 h-10' />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Show</h3>
                            <p className="text-xl font-bold my-1 text-gray-800 truncate">
                                {metrics.showTimeFilter}
                            </p>
                            <p className="text-gray-400 text-xs">Current filter</p>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
                        <div className="p-3 bg-red-50 rounded-full">
                            <img src={movieicon} alt='movie' className='w-10 h-10' />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
                            <p className="text-xl font-bold my-1 text-gray-800 truncate">
                                {metrics.mostPopularShowTime}
                            </p>
                            <p className="text-gray-400 text-xs">Most booked time</p>
                        </div>
                    </div>
                )}

                {/* Movie Card (Conditional) */}
                {metrics.filteredMovie ? (
                    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
                        <div className="p-3 bg-red-50 rounded-full">
                            <img src={movieicon} alt='movie' className='w-10 h-10' />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Movie</h3>
                            <p className="text-xl font-bold my-1 text-gray-800 truncate">
                                {metrics.filteredMovie}
                            </p>
                            <p className="text-gray-400 text-xs">Current filter</p>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
                        <div className="p-3 bg-red-50 rounded-full">
                            <img src={movieicon} alt='movie' className='w-10 h-10' />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Movie</h3>
                            <p className="text-xl font-bold my-1 text-gray-800 truncate">
                                {metrics.mostPopularMovie || 'N/A'}
                            </p>
                            <p className="text-gray-400 text-xs">Most booked film</p>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderDateRangeSelector = () => (
        <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
                Date Range
            </label>
            <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
                <div className="relative w-full sm:w-40">
                    <select
                        value={dateOption}
                        onChange={(e) => setDateOption(e.target.value)}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-gray-200 appearance-none"
                    >
                        {getDateOptions().map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                    </div>
                </div>

                {dateOption === "custom" && (
                    <div className="flex items-center gap-2 w-full sm:w-auto">
                        <input
                            type="date"
                            value={customRange.start}
                            onChange={(e) => setCustomRange(prev => ({ ...prev, start: e.target.value }))}
                            className="w-full sm:w-40 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                        />
                        <span className="text-gray-500">to</span>
                        <input
                            type="date"
                            value={customRange.end}
                            onChange={(e) => setCustomRange(prev => ({ ...prev, end: e.target.value }))}
                            className="w-full sm:w-40 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                        />
                    </div>
                )}
            </div>
        </div>
    );

    // const renderArchiveFilter = () => (
    //     <div className="flex items-center mt-2">
    //       <input
    //         type="checkbox"
    //         id="includeArchived"
    //         checked={includeArchived}
    //         onChange={(e) => {
    //           setIncludeArchived(e.target.checked);
    //           // Trigger a refetch when the checkbox changes
    //           if (theatreFilter) {
    //             fetchMoviesAndSchedules();
    //           }
    //         }}
    //         className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
    //       />
    //       <label htmlFor="includeArchived" className="ml-2 block text-sm text-gray-700">
    //         Include Archived Movies
    //       </label>
    //     </div>
    //   );








    const renderArchiveFilter = () => (
        <div className="flex items-center mt-2">
            <input
                type="checkbox"
                id="includeArchived"
                checked={includeArchived}
                onChange={(e) => {
                    const newValue = e.target.checked;
                    console.log('Checkbox changed to:', newValue); // Debug log
                    setIncludeArchived(newValue);
                    // Trigger refetch when checkbox changes
                    if (theatreFilter) {
                        // Small delay to ensure state is updated
                        setTimeout(() => {
                            fetchMoviesAndSchedules();
                        }, 0);
                    }
                }}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="includeArchived" className="ml-2 block text-sm text-gray-700">
                Include Archived Movies
            </label>
        </div>
    );


    //   const renderMovieDropdown = () => (
    //     <div>
    //       <label className="block text-sm font-medium text-gray-700 mb-1">
    //         Movie
    //       </label>
    //       <select
    //         value={movieFilter}
    //         onChange={(e) => setMovieFilter(e.target.value)}
    //         disabled={!theatreFilter}
    //         className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${
    //           !theatreFilter ? "bg-gray-100 text-gray-400" : ""
    //         }`}
    //       >
    //         <option value="">All Movies</option>
    //         {availableMovies.map(movie => (
    //           <option key={movie._id} value={movie.name}>
    //             {movie.name} {movie.theatreDetails[0]?.isArchived ? "(Archived)" : ""}
    //           </option>
    //         ))}
    //       </select>
    //     </div>
    //   );












    // const renderMovieDropdown = () => (
    //     <div>
    //       <label className="block text-sm font-medium text-gray-700 mb-1">
    //         Movie
    //       </label>
    //       <select
    //         value={movieFilter}
    //         onChange={(e) => {
    //           const selectedMovieName = e.target.value;
    //           setMovieFilter(selectedMovieName);
    //           setShowTimeFilter(""); // Reset show time filter when movie changes

    //           // Find the selected movie and update show times/dates
    //           const selectedMovie = availableMovies.find(m => m.name === selectedMovieName);
    //           if (selectedMovie) {
    //             updateShowTimesAndDates(selectedMovie);
    //           }
    //         }}
    //         disabled={!theatreFilter}
    //         className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${
    //           !theatreFilter ? "bg-gray-100 text-gray-400" : ""
    //         }`}
    //       >
    //         <option value="">All Movies</option>
    //         {availableMovies.map(movie => (
    //           <option key={movie._id} value={movie.name}>
    //             {movie.name} 
    //             {movie.validities?.[0]?.isArchived ? "(Archived)" : ""}
    //           </option>
    //         ))}
    //       </select>
    //     </div>
    //   );













    const renderMovieDropdown = () => (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Movie(s)</label>
            <div className={`border rounded-md p-2 max-h-44 overflow-auto ${!theatreFilter ? 'bg-gray-100 text-gray-400' : ''}`}>
                {availableMovies.map(movie => {
                    const name = movie.name;
                    const checked = selectedMovies.includes(name);
                    return (
                        <label key={movie._id} className="flex items-center gap-2 py-1">
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                    let next = [...selectedMovies];
                                    if (e.target.checked) {
                                        next.push(name);
                                    } else {
                                        next = next.filter(m => m !== name);
                                    }
                                    setSelectedMovies(next);
                                    if (next.length === 1) {
                                        setMovieFilter(next[0]);
                                        setShowTimeFilter('');
                                        const sel = availableMovies.find(m => m.name === next[0]);
                                        if (sel) updateShowTimesAndDates(sel);
                                    } else {
                                        setMovieFilter('');
                                        setShowTimeFilter('');
                                    }
                                }}
                                disabled={!theatreFilter}
                                className="h-4 w-4"
                            />
                            <span>{name}{movie.validities?.some(v => v.isArchived) ? ' (Archived)' : ''}</span>
                        </label>
                    );
                })}
            </div>
            <div className="flex gap-2 mt-1">
                <button type="button" onClick={() => setSelectedMovies(availableMovies.map(m => m.name))} className="text-xs text-blue-600">Select All</button>
                <button type="button" onClick={() => { setSelectedMovies([]); setMovieFilter(''); setShowTimeFilter(''); }} className="text-xs text-blue-600">Clear</button>
            </div>
        </div>
    );



    const renderShowTimeDropdown = () => {
        // Get show times for the selected movie only
        const movieShowTimes = movieFilter
            ? (() => {
                const selectedMovie = availableMovies.find(m => m.name === movieFilter);
                if (!selectedMovie) return [];

                const times = new Set();
                selectedMovie.validities?.forEach(validity => {
                    validity.shows?.forEach(show => {
                        if (show.time) times.add(show.time);
                    });
                });
                return Array.from(times).sort();
            })()
            : availableShowTimes; // Fallback to all show times if no movie selected

        return (
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Show Time
                </label>
                <select
                    value={showTimeFilter}
                    onChange={(e) => setShowTimeFilter(e.target.value)}
                    disabled={!movieFilter || (selectedMovies && selectedMovies.length > 1)}
                    className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${(!movieFilter || (selectedMovies && selectedMovies.length > 1)) ? "bg-gray-100 text-gray-400" : ""}`}
                >
                    <option value="">All Show Times</option>
                    {movieShowTimes.map(time => (
                        <option key={time} value={time}>
                            {time}
                        </option>
                    ))}
                </select>
                {selectedMovies && selectedMovies.length > 1 && (
                    <p className="text-xs text-gray-500 mt-1">Select a single movie to filter by show time.</p>
                )}
            </div>
        );
    };

    return (
        <div className="md:max-w-5xl mx-auto mb-4">
            <div className="mb-6">
                <div className="bg-white rounded-lg shadow-md p-4 mb-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                        Filter Tickets
                    </h3>

                    <div className="flex flex-col sm:flex-row gap-4 mb-4">
                        {/* Theatre Dropdown */}
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Theatre
                            </label>
                            <select
                                value={theatreFilter}
                                onChange={(e) => setTheatreFilter(e.target.value)}
                                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                            >
                                <option value="">Select Theatre</option>
                                {theatres.map(theatre => (
                                      <option key={theatre._id} value={theatre.name}>
                                          {theatre.name}
                                      </option>
                                  ))}
                            </select>
                            {renderArchiveFilter()}
                        </div>

                        {/* Date Range */}









                        <div className="flex items-center gap-3 mb-2">
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    className="form-radio"
                                    checked={dateType === "booking"}
                                    onChange={() => setDateType("booking")}
                                />
                                <span className="ml-2 text-sm text-gray-700">Booking Date</span>
                            </label>
                            <label className="inline-flex items-center ml-4">
                                <input
                                    type="radio"
                                    className="form-radio"
                                    checked={dateType === "show"}
                                    onChange={() => setDateType("show")}
                                />
                                <span className="ml-2 text-sm text-gray-700">Show Date</span>
                            </label>
                        </div>



                        {renderDateRangeSelector()}
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
                        {renderMovieDropdown()}
                        {renderShowTimeDropdown()}

                        {/* Status Dropdown */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Status
                            </label>
                            <select
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                            >
                                <option value="SUCCESS_OR_COMPLETED">Success/Completed</option>
                                <option value="COMPLETED">Completed</option>
                                <option value="PENDING">Pending</option>
                                <option value="FAILED">Failed</option>
                                <option value="">All Statuses</option>
                            </select>
                        </div>

                        {/* Payment Method */}
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Payment Method
                            </label>
                            <select
                                value={paymentMethodFilter}
                                onChange={(e) => setPaymentMethodFilter(e.target.value)}
                                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                            >
                                <option value="">All Methods</option>
                                {getOptions("paymentMethod", ticketData).map((val) => (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="flex flex-wrap gap-2 mt-4">
                        {/* Clear Filters Button */}
                        <button
                            onClick={clearFilters}
                            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                            </svg>
                            Clear All Filters
                        </button>

                        {/* Export CSV Button */}
                        <button
                            onClick={exportCSV}
                            disabled={loading || filteredData.length === 0}
                            className={`px-4 py-2 rounded-md transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none ${loading || filteredData.length === 0
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-black hover:bg-gray-800 text-white"
                                }`}
                        >
                            {loading ? (
                                <>
                                    <svg
                                        className="animate-spin h-4 w-4 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    Exporting...
                                </>
                            ) : (
                                <>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    Generate Report
                                </>
                            )}
                        </button>

                        <button
                            onClick={findDuplicateSeats}
                            disabled={loading || filteredData.length === 0}
                            className={`px-4 py-2 rounded-md transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none ${loading || filteredData.length === 0
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-yellow-500 hover:bg-yellow-600 text-white"
                                }`}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Find Duplicate Seats
                        </button>










                        <button
                            onClick={() => {
                                const theatreOk = isTicketAdmin ? !!theatreFilter : true;
                                if (dateOption && theatreOk) {
                                    fetchTicketData();
                                } else {
                                    alert(isTicketAdmin ?
                                        "Please select at least Theatre and Date Range" :
                                        "Please select a Date Range");
                                }
                            }}
                            disabled={loading}
                            className={`px-4 py-2 rounded-md transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none ${loading
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-black hover:bg-gray-800 text-white"
                                }`}
                        >
                            {loading ? (
                                <>
                                    <svg
                                        className="animate-spin h-4 w-4 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    Checking...
                                </>
                            ) : (
                                <>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    Check Report
                                </>
                            )}
                        </button>


                    </div>
                </div>
            </div>

            {/* {!loading && filteredData.length > 0 && (
                <SummaryCards data={filteredData} />
            )} */}








            {/* Add this after your filter section and before the results */}
            {!loading && filteredData.length > 0 && (
                <>
                    {/* Global Search Bar */}
                    <div className="bg-white rounded-lg shadow-md p-4 mb-4">
                        <div className="flex items-center gap-4">
                            <div className="flex-1">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Search in displayed results
                                </label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Search by booking ID, phone number, movie, theatre, etc..."
                                        value={globalSearch}
                                        onChange={(e) => {
                                            setGlobalSearch(e.target.value);
                                            setPage(0); // Reset to first page when searching
                                        }}
                                        className="w-full border border-gray-300 rounded-md pl-10 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <svg
                                        className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                    {globalSearch && (
                                        <button
                                            onClick={() => {
                                                setGlobalSearch('');
                                                setPage(0);
                                            }}
                                            className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
                                        >
                                            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="flex-shrink-0">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Column Filters
                                </label>
                                <button
                                    onClick={() => setShowColumnFilters(v => !v)}
                                    className="px-3 py-2 rounded-md bg-gray-800 text-white hover:bg-gray-700"
                                >
                                    {showColumnFilters ? 'Hide Filters' : 'Show Filters'}
                                </button>
                            </div>

                            {/* Copy Button */}
                            <div className="flex-shrink-0">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Copy Table
                                </label>
                                <button
                                    onClick={copyTableToClipboard}
                                    disabled={paginatedData.length === 0}
                                    className={`px-4 py-2 rounded-md transition-colors flex items-center gap-2 ${paginatedData.length === 0
                                        ? "bg-gray-300 cursor-not-allowed text-gray-500"
                                        : "bg-blue-600 hover:bg-blue-700 text-white"
                                        }`}
                                >
                                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                    </svg>
                                    {copyStatus || 'Copy Table'}
                                </button>
                            </div>
                        </div>

                        {/* Column Visibility */}
                        {showColumnFilters && (
                            <div className="mt-4">
                                <div className="flex items-center gap-3 mb-2">
                                    <button className="text-xs text-blue-600" onClick={() => {
                                        const all = {};
                                        reportColumns.forEach(c => { if (!c.adminOnly || role === 'superAdmin') all[c.field] = true; });
                                        setVisibleColumns(all);
                                    }}>Select All</button>
                                    <button className="text-xs text-blue-600" onClick={() => {
                                        const none = {};
                                        reportColumns.forEach(c => { if (!c.adminOnly || role === 'superAdmin') none[c.field] = false; });
                                        setVisibleColumns(none);
                                    }}>Deselect All</button>
                                    <button className="text-xs text-blue-600" onClick={() => setVisibleColumns({})}>Clear</button>
                                </div>
                                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
                                    {reportColumns
                                        .filter(c => !c.adminOnly || role === 'superAdmin')
                                        .map(c => (
                                            <label key={c.field} className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={isColVisible(c.field)}
                                                    onChange={(e) => setVisibleColumns(prev => ({ ...prev, [c.field]: e.target.checked }))}
                                                />
                                                <span>{c.label}</span>
                                            </label>
                                        ))}
                                </div>
                            </div>
                        )}

                        {/* Search Results Info */}
                        {globalSearch && (
                            <div className="mt-2 text-sm text-gray-600">
                                Found {searchFilteredData.length} results for "{globalSearch}"
                            </div>
                        )}
                    </div>

                    <SummaryCards data={searchFilteredData} />
                </>
            )}






            {/* Results Section */}
            {loading ? (
                <div className="flex justify-center items-center h-24">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
                </div>
            ) : filteredData.length === 0 ? (
                <div className="text-center py-12">
                    <div className="mx-auto h-24 w-24 text-gray-400">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1}
                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                    <h3 className="mt-2 text-lg font-medium text-gray-700">
                        No tickets found
                    </h3>
                    <p className="mt-1 text-gray-500">
                        Try adjusting your search or filter criteria
                    </p>
                </div>
            ) : (
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-black">
                                <tr>
                                    {reportColumns
                                    .filter(col => (!col.adminOnly || role === "superAdmin") && isColVisible(col.field))
                                    .map((col) => (
                                        <th
                                            key={col.field}
                                            scope="col"
                                            className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider cursor-pointer hover:bg-gray-700 transition-colors duration-150"
                                            onClick={() => handleSort(col.field)}
                                        >
                                            <div className="flex items-center">
                                                {col.label}
                                                {orderBy === col.field && (
                                                    <span className="ml-2">
                                                        {order === "asc" ? (
                                                            <svg
                                                                className="w-4 h-4"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={2}
                                                                    d="M5 15l7-7 7 7"
                                                                />
                                                            </svg>
                                                        ) : (
                                                            <svg
                                                                className="w-4 h-4"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={2}
                                                                    d="M19 9l-7 7-7-7"
                                                                />
                                                            </svg>
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                        </th>
                                    ))}


                                </tr>
                            </thead>

                            <tbody className="bg-white divide-y divide-gray-200">
                                {paginatedData.map((t, idx) => {


                                    // const isRefundDisabled = refundLoading || (t.refundTransactionId && t.refundStatus !== "FAILED" && t.refundStatus !== "NOT_INITIATED");

                                    // console.log("isRefundDisabled",isRefundDisabled)

                                    //                                     const isRefundDisabled = refundLoading || 
                                    //   (t.refundTransactionId && t.refundStatus !== "FAILED" && t.refundStatus !== "NOT_INITIATED");

                                    const isRefundDisabled = refundLoading ||
                                        (t.refundStatus === "SUCCESS") ||
                                        (t.refundTransactionId && t.refundStatus !== "FAILED" && t.refundStatus !== "NOT_INITIATED");


                                    console.log('isRefundDisabled', isRefundDisabled, t.refundStatus);

                                    const getPaymentReference = (paymentDetails) => {
                                        if (!paymentDetails || Object.keys(paymentDetails).length === 0) {
                                            return "MANUAL ENTRY";
                                        }

                                        const instrument = paymentDetails?.paymentInstrument;

                                        if (!instrument && paymentDetails.merchantTransactionId) {
                                            return paymentDetails.merchantTransactionId;
                                        }

                                        if (!instrument) return "MANUAL ENTRY";

                                        if (instrument.type === "UPI") {
                                            return instrument.utr || instrument.upiTransactionId || "N/A";
                                        }

                                        if (instrument.type === "CARD") {
                                            return instrument.arn || instrument.cardToken || instrument.last4 || "N/A";
                                        }

                                        return instrument.referenceId ||
                                            instrument.transactionId ||
                                            paymentDetails.transactionId ||
                                            paymentDetails.merchantTransactionId ||
                                            "MANUAL ENTRY";
                                    };

                                    return (
                                        <tr key={idx} className="hover:bg-gray-50 transition-colors duration-150">
                                            {/* Booking Date */}
                                            {isColVisible('bookingDate') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                <div className="group relative">
                                                    <div className="cursor-pointer" title="Booking Date">
                                                        {formatDateToDDMMYYYY(formatTo12Hour(t.bookingDate)?.split(' ')[0])}
                                                    </div>
                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                        <span className="font-medium">Booking Date:</span><br />
                                                        {formatDateToDDMMYYYY(formatTo12Hour(t.bookingDate)?.split(' ')[0])}
                                                    </div>
                                                </div>
                                            </td>)}

                                            {/* Booking Time */}
                                            {isColVisible('bookingTime') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <span className="px-2 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-medium cursor-pointer">
                                                        {formatTo12Hour(t.bookingDate)?.split(' ').slice(1).join(' ') || 'N/A'}
                                                    </span>
                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                        <span className="font-medium">Booking Time:</span><br />
                                                        {formatTo12Hour(t.bookingDate)?.split(' ').slice(1).join(' ') || 'N/A'}
                                                    </div>
                                                </div>
                                            </td>)}

                                            {/* Show Date */}
                                            {isColVisible('showDate') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="cursor-pointer" title="Show Date">
                                                        {formatDateToDDMMYYYY(t.showDate)}
                                                    </div>
                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                        <span className="font-medium">Show Date:</span><br />
                                                        {formatDateToDDMMYYYY(t.showDate)}
                                                    </div>
                                                </div>
                                            </td>)}

                                            {/* Show Time */}
                                            {isColVisible('showTime') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium cursor-pointer">
                                                        {t.showTime}
                                                    </span>
                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                        <span className="font-medium">Show Time:</span><br />
                                                        {t.showTime}
                                                    </div>
                                                </div>
                                            </td>)}

                                            {/* Booking ID */}
                                            {isColVisible('bookingId') && (
                                            <td className="px-6 py-4 text-sm font-semibold text-gray-900">
                                                <div className="group relative">
                                                    <div className="break-all leading-tight cursor-pointer" title="Full booking ID">
                                                        {t.bookingId}
                                                    </div>
                                                    {t.bookingId && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">Full Booking ID:</span><br />
                                                            {t.bookingId}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Movie */}
                                            {isColVisible('movieName') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">
                                                <div className="group relative">
                                                    <div className="max-w-40 truncate cursor-pointer" title={t.movieName}>
                                                        {t.movieName}
                                                    </div>
                                                    {t.movieName && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">Movie:</span><br />
                                                            {t.movieName}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Theatre */}
                                            {isColVisible('theatreName') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="max-w-32 truncate cursor-pointer" title={t.theatreName}>
                                                        {t.theatreName}
                                                    </div>
                                                    {t.theatreName && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">Theatre:</span><br />
                                                            {t.theatreName}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* User Phone */}
                                            {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="cursor-pointer" title="Phone Number">
                                                        {t.userPhoneNumber}
                                                    </div>
                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                        <span className="font-medium">Phone:</span><br />
                                                        {t.userPhoneNumber}
                                                    </div>
                                                </div>
                                            </td> */}







                                            {/* User Phone */}
                                            {isColVisible('userPhoneNumber') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="flex items-center gap-2 cursor-pointer" title="Phone Number">
                                                        <span>
                                                            {t.userPhoneNumber?.startsWith('+') ? t.userPhoneNumber : `+${t.userPhoneNumber || ''}`}
                                                        </span>

                                                        {/* Copy Icon Button */}
                                                        <button
                                                            onClick={(e) => {  // ✅ Pass event as parameter instead of using global
                                                                const phoneNum = t.userPhoneNumber || '';
                                                                const formatted = phoneNum.startsWith('+') ? phoneNum : `+${phoneNum}`;
                                                                navigator.clipboard.writeText(formatted)
                                                                    .then(() => {
                                                                        // Show temporary success feedback
                                                                        const btn = e.target.closest('button');  // ✅ Use 'e' instead of 'event'
                                                                        const originalContent = btn.innerHTML;
                                                                        btn.innerHTML = '✅';
                                                                        setTimeout(() => btn.innerHTML = originalContent, 1000);
                                                                    })
                                                                    .catch(() => {
                                                                        console.error('Failed to copy phone number');
                                                                    });
                                                            }}
                                                            className="text-gray-400 hover:text-blue-500 transition-colors p-1 rounded hover:bg-gray-100"
                                                            title="Copy phone number"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="h-4 w-4"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={2}
                                                                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                                                />
                                                            </svg>
                                                        </button>
                                                    </div>

                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                        <span className="font-medium">Phone:</span><br />
                                                        {t.userPhoneNumber?.startsWith('+') ? t.userPhoneNumber : `+${t.userPhoneNumber || ''}`}
                                                        <br />
                                                        <span className="text-gray-300">Click icon to copy</span>
                                                    </div>
                                                </div>
                                            </td>)}


                                            {/* Seats */}
                                            {isColVisible('bookedSeats') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="flex flex-wrap gap-1 max-w-xs cursor-pointer">
                                                        {t.bookedSeats?.map((seat, i) => (
                                                            <span
                                                                key={i}
                                                                className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs"
                                                            >
                                                                {seat}
                                                            </span>
                                                        ))}
                                                    </div>
                                                    {t.bookedSeats && t.bookedSeats.length > 0 && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">All Seats:</span><br />
                                                            {t.bookedSeats.join(', ')}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Amount */}
                                            {isColVisible('totalAmount') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-green-600">
                                                ₹{t.totalAmount}
                                            </td>)}

                                            {/* Payment Method */}
                                            {isColVisible('paymentMethod') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs font-medium">
                                                    {t.paymentMethod}
                                                </span>
                                            </td>)}

                                            {/* Payment Mode */}
                                            {isColVisible('paymentMode') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                {t.paymentMode || 'N/A'}
                                            </td>)}

                                            {/* Transaction ID */}
                                            {isColVisible('transactionId') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">
                                                <div className="group relative">
                                                    <div className="max-w-32 truncate cursor-pointer" title={t.transactionId || "N/A"}>
                                                        {t.transactionId || 'N/A'}
                                                    </div>
                                                    {t.transactionId && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">Transaction ID:</span><br />
                                                            {t.transactionId}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Status */}
                                            {isColVisible('transactionStatus') && (
                                            <td className="px-4 py-3 whitespace-nowrap">
                                                <span
                                                    className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${t.transactionStatus === "PENDING"
                                                        ? "bg-yellow-100 text-yellow-800"
                                                        : t.transactionStatus === "COMPLETED"
                                                            ? "bg-green-100 text-green-800"
                                                            : "bg-red-100 text-red-800"
                                                        }`}
                                                >
                                                    {t.transactionStatus}
                                                </span>
                                            </td>)}

                                            {/* Invoice Number */}
                                            {isColVisible('invoiceNumber') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">
                                                <div className="group relative">
                                                    <div className="cursor-pointer" title="Invoice Number">
                                                        {t.invoiceNumber || "N/A"}
                                                    </div>
                                                    {t.invoiceNumber && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-nowrap">
                                                            <span className="font-medium">Invoice #:</span><br />
                                                            {t.invoiceNumber}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Purchase Cost */}
                                            {isColVisible('purchaseCost') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                ₹{t.purchaseCost || "0"}
                                            </td>)}

                                            {/* Base Amount */}
                                            {isColVisible('priceSplit.baseAmount.value') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                ₹{t.priceSplit?.baseAmount?.value || "N/A"}
                                            </td>)}

                                            {/* Total Tax */}
                                            {isColVisible('priceSplit.totalTax.value') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                ₹{t.priceSplit?.totalTax?.value || "N/A"}
                                            </td>)}

                                            {/* Platform Fee */}
                                            {isColVisible('priceSplit.platformFee.total.value') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                ₹{t.priceSplit?.platformFee?.total?.value || "N/A"}
                                            </td>)}

                                            {/* Gateway Charges */}
                                            {isColVisible('priceSplit.gatewayCharges.total.value') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                ₹{t.priceSplit?.gatewayCharges?.total?.value || "N/A"}
                                            </td>)}

                                            {/* Discount */}
                                            {isColVisible('priceSplit.discount.value') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                ₹{t.priceSplit?.discount?.value || "0"}
                                            </td>)}

                                            {/* Merchant Transaction ID */}
                                            {isColVisible('paymentDetails.merchantTransactionId') && (
                                            <td className="px-6 py-4 text-sm text-gray-600 font-mono">
                                                <div className="group relative">
                                                    <div className="break-all leading-tight cursor-pointer" title="Full transaction ID">
                                                        {t.paymentDetails?.merchantTransactionId || "N/A"}
                                                    </div>
                                                    {t.paymentDetails?.merchantTransactionId && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">Merchant Transaction ID:</span><br />
                                                            {t.paymentDetails.merchantTransactionId}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Payment Reference */}
                                            {isColVisible('paymentReference') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="flex flex-col cursor-pointer">
                                                        <span className="font-mono text-xs">
                                                            <div className="max-w-32 truncate" title={getPaymentReference(t.paymentDetails)}>
                                                                {getPaymentReference(t.paymentDetails)}
                                                            </div>
                                                        </span>
                                                        <span className="text-xs text-gray-400">
                                                            {(() => {
                                                                const reference = getPaymentReference(t.paymentDetails);

                                                                if (reference === "MANUAL ENTRY" || t.userId === "MANUAL" || !t.paymentDetails || Object.keys(t.paymentDetails).length === 0) {
                                                                    return "MANUAL";
                                                                }

                                                                const instrument = t.paymentDetails?.paymentInstrument;

                                                                if (instrument?.type === "UPI") {
                                                                    if (instrument.utr) return "UTR";
                                                                    if (instrument.upiTransactionId) return "UPI ID";
                                                                }

                                                                if (instrument?.type === "CARD") {
                                                                    if (instrument.arn) return "ARN";
                                                                    if (instrument.cardToken) return "TOKEN";
                                                                    if (instrument.last4) return "CARD";
                                                                }

                                                                if (reference === t.paymentDetails?.merchantTransactionId) {
                                                                    return "MERCHANT";
                                                                }

                                                                return "REF";
                                                            })()}
                                                        </span>
                                                    </div>
                                                    <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                        <span className="font-medium">Payment Reference:</span><br />
                                                        {getPaymentReference(t.paymentDetails)}
                                                    </div>
                                                </div>
                                            </td>)}

                                            {/* Account Holder */}
                                            {isColVisible('paymentDetails.paymentInstrument.accountHolderName') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <div className="group relative">
                                                    <div className="max-w-32 truncate cursor-pointer" title={t.paymentDetails?.paymentInstrument?.accountHolderName || "N/A"}>
                                                        {t.paymentDetails?.paymentInstrument?.accountHolderName || "N/A"}
                                                    </div>
                                                    {t.paymentDetails?.paymentInstrument?.accountHolderName && (
                                                        <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 z-10 whitespace-normal break-words max-w-xs">
                                                            <span className="font-medium">Account Holder:</span><br />
                                                            {t.paymentDetails.paymentInstrument.accountHolderName}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>)}

                                            {/* Payment Type */}
                                            {isColVisible('paymentDetails.paymentInstrument.type') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${t.paymentDetails?.paymentInstrument?.type === "UPI"
                                                    ? "bg-green-50 text-green-700"
                                                    : t.paymentDetails?.paymentInstrument?.type === "CARD"
                                                        ? "bg-blue-50 text-blue-700"
                                                        : "bg-gray-50 text-gray-700"
                                                    }`}>
                                                    {t.paymentDetails?.paymentInstrument?.type || "N/A"}
                                                </span>
                                            </td>)}

                                            {/* Account Type */}
                                            {isColVisible('paymentDetails.paymentInstrument.accountType') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                {t.paymentDetails?.paymentInstrument?.accountType || "N/A"}
                                            </td>)}

                                            {/* User ID */}
                                            {isColVisible('userId') && (
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${t.userId === "MANUAL"
                                                    ? "bg-orange-50 text-orange-700"
                                                    : "bg-gray-50 text-gray-700"
                                                    }`}>
                                                    {t.userId || "N/A"}
                                                </span>
                                            </td>)}

                                            {/* For the Refund and the Check Status */}
                                            {/* <td>
                                        
                                                {role === "superAdmin" && (

                                                    <div className="flex gap-2">
                                                      


                                                        <button
                                                            onClick={() => openOtpModalForRefund(t.bookingId)}
                                                            disabled={isRefundDisabled || refundedBookings.has(String(t.bookingId))}
                                                            className={`px-2.5 py-1.5 rounded text-sm ${isRefundDisabled || refundedBookings.has(String(t.bookingId))
                                                                ? "bg-gray-400 cursor-not-allowed"
                                                                : "bg-blue-500 hover:bg-blue-600 text-white"
                                                                }`}
                                                        >
                                                            Refund
                                                        </button>

                                                        <button
                                                            className="px-2.5 py-1.5 rounded text-sm bg-rose-600 text-white hover:bg-rose-700 shadow-sm"
                                                            onClick={() => handleCheckStatus(t.bookingId)}
                                                            disabled={statusLoading}
                                                        >
                                                            Check Status
                                                        </button>



                                                    </div>

                                                )}


                                            </td> */}



                                            {/* Refund / Status actions */}
                                            


                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
                        <div className="flex items-center">
                            <p className="text-sm text-gray-700 mr-2">Rows per page:</p>
                            <select
                                className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none bg-white"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setPage(0);
                                }}
                            >
                                <option value={100}>100</option>
                                <option value={500}>500</option>
                                <option value={1000}>1000</option>
                            </select>
                        </div>

                        <div className="flex items-center space-x-4">
                            <button
                                onClick={() => setPage(Math.max(0, page - 1))}
                                disabled={page === 0}
                                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Previous
                            </button>
                            <button
                                onClick={() =>
                                    setPage(
                                        Math.min(
                                            Math.ceil(filteredData.length / rowsPerPage) - 1,
                                            page + 1
                                        )
                                    )
                                }
                                disabled={
                                    page >= Math.ceil(filteredData.length / rowsPerPage) - 1
                                }
                                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* OTP Modal */}
            {otpModalOpen && (
                <div className="fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <div className="bg-white rounded-lg shadow-xl w-[22rem] p-5 border border-gray-200">
                        <div className="mb-4">
                            <h2 className="text-lg font-semibold text-gray-800">Refund Verification</h2>
                            <p className="text-sm text-gray-600 mt-1">
                                An OTP has been sent to the registered contact for booking
                                <span className="font-medium"> {currentRefundBookingId}</span>.
                            </p>
                        </div>
                        {otpSending ? (
                            <div className="flex items-center text-sm text-gray-600 mb-4">Sending OTP…</div>
                        ) : (
                            <>
                                {otpMessage && (
                                    <div className="mb-3 text-green-700 bg-green-50 border border-green-200 rounded px-3 py-2 text-sm">
                                        {otpMessage}
                                    </div>
                                )}
                                {otpError && (
                                    <div className="mb-3 text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2 text-sm">
                                        {otpError}
                                    </div>
                                )}
                                {!otpCompleted ? (
                                    <>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Enter OTP</label>
                                        <input
                                            type="text"
                                            value={otpValue}
                                            onChange={(e) => setOtpValue(e.target.value)}
                                            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                                            placeholder="Enter the 4-6 digit OTP"
                                            disabled={otpCompleted}
                                        />
                                        <div className="mt-2">
                                            <button
                                                onClick={async () => {
                                                    setOtpMessage("");
                                                    setOtpError("");
                                                    setOtpSending(true);
                                                    try {
                                                        const again = await RefundServices.sendRefundOtp(String(currentRefundBookingId));
                                                        if (again?.success || again?.status === true) {
                                                            setOtpMessage("OTP re-sent. Please enter the new code.");
                                                        } else {
                                                            setOtpError(again?.message || "Failed to resend OTP.");
                                                        }
                                                    } catch (err) {
                                                        setOtpError(err?.message || "Failed to resend OTP.");
                                                    } finally {
                                                        setOtpSending(false);
                                                    }
                                                }}
                                                disabled={otpSending || otpVerifying || otpCompleted}
                                                className={`text-sm underline ${otpSending || otpVerifying || otpCompleted ? 'text-gray-400' : 'text-blue-600 hover:text-blue-700'}`}
                                            >
                                                Resend OTP
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="text-sm text-gray-700">
                                        Refund initiated for booking <span className="font-medium">{currentRefundBookingId}</span>.<br />
                                        Please close this window and click "Check Status" in the report to track the refund.
                                    </div>
                                )}
                            </>
                        )}
                        <div className="mt-6 flex justify-end gap-2">
                            {!otpCompleted ? (
                                <>
                                    <button
                                        onClick={() => setOtpModalOpen(false)}
                                        className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
                                        disabled={otpVerifying}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={verifyOtpAndRefund}
                                        disabled={otpSending || otpVerifying || otpCompleted}
                                        className={`px-4 py-2 rounded-md text-white ${otpSending || otpVerifying || otpCompleted ? 'bg-gray-400' : 'bg-black hover:bg-gray-800'}`}
                                    >
                                        {otpVerifying ? 'Verifying…' : 'Verify & Refund'}
                                    </button>
                                </>
                            ) : (
                                <button
                                    onClick={() => setOtpModalOpen(false)}
                                    className="px-4 py-2 rounded-md text-white bg-black hover:bg-gray-800"
                                >
                                    Close
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

//

export default SingleReport;

